import React, { FC } from 'react';
import { ReactComponent as RiderIcon } from 'assets/icons/motorbike.svg';
import { ReactComponent as CalendarIcon } from 'assets/icons/calendar.svg';
import { PartnerType } from 'models/partner.model';
import { formatNumber } from 'utils/functions';

type PartnerCardHeaderType = {
  partner: PartnerType;
  onClick: (arg1: any) => void;
};
const PartnersCardBody: FC<PartnerCardHeaderType> = ({ partner, onClick }) => {
  return (
    <div className='px-4 text-sm space-y-2 cursor-pointer grow' onClick={onClick}>
      <div className='flex flex-wrap gap-2 justify-between items-center'>
        <p className='text-gray-6 text-base font-medium'>{partner.name}</p>
        <p className='flex items-center gap-2 whitespace-nowrap'>
          <CalendarIcon />
          <span>{new Date(partner.created_at).toDateString()}</span>
        </p>
      </div>
      <div className='flex flex-wrap gap-2 justify-between items-center'>
        <p className='flex items-center gap-2'>
          <RiderIcon />
          <span>{partner.riders_count} riders</span>
        </p>
        <p className='flex items-center gap-2'>
          <span className='w-2 h-2 rounded-full bg-green-4'></span>
          {partner.online_riders_count} online
        </p>
      </div>
      <div className='flex flex-wrap gap-2 justify-between items-center'>
        <p>Trips completed: {partner.trips_completed}</p>
        <p>Earned: {formatNumber(partner.earned)}</p>
      </div>
    </div>
  );
};

export default PartnersCardBody;
